import React from 'react'
import PropTypes from 'prop-types'
import {Heading} from '@salesforce/retail-react-app/app/components/shared/ui'

const Title = ({
    title,
    color,
    tag,
    titleSizeMobile,
    titleSizeTablet,
    titleSizeDesktop,
    titleSizeXl = titleSizeDesktop,
    titleFontFamily,
    titleFontWeight = '500'
}) => {
    return (
        <Heading
            as={tag}
            margin="0"
            fontSize={{
                base: titleSizeMobile,
                md: titleSizeTablet,
                lg: titleSizeDesktop,
                xl: titleSizeXl
            }}
            fontFamily={titleFontFamily || 'caslon'}
            fontWeight={titleFontWeight}
            lineHeight="normal"
            textAlign="center"
            color={color}
        >
            {title}
        </Heading>
    )
}

Title.propTypes = {
    title: PropTypes.string,
    color: PropTypes.string,
    tag: PropTypes.string,
    titleFontFamily: PropTypes.string,
    titleFontWeight: PropTypes.string,
    titleSizeMobile: PropTypes.string,
    titleSizeDesktop: PropTypes.string,
    titleSizeTablet: PropTypes.string,
    titleSizeXl: PropTypes.string
}

export default Title
